import { apiRequest } from './index';

/**
 * Fetch agent's schedule
 *
 * @param {number} agentId Agent ID
 * @returns {Promise<Array>} Schedule entries
 */
export const fetchAgentSchedule = async (agentId) => {
  try {
    const response = await apiRequest({
      url: `/api/schedule.php?method=get_agent_schedule&agent_id=${agentId}`,
      method: 'GET'
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching schedule for agent ID ${agentId}:`, error);
    throw error;
  }
};

/**
 * Update agent's schedule
 *
 * @param {number} agentId Agent ID
 * @param {Array} scheduleData Schedule entries
 * @returns {Promise<Object>} Result
 */
export const updateAgentSchedule = async (agentId, scheduleData) => {
  try {
    // Убедимся, что agentId - это число
    const numericAgentId = Number(agentId);

    if (isNaN(numericAgentId)) {
      throw new Error(`Invalid agent ID: ${agentId}`);
    }

    // Используем POST-запрос с правильными параметрами
    const response = await apiRequest({
      url: `/api/schedule.php?method=update_schedule&agent_id=${numericAgentId}`,
      method: 'POST',
      data: scheduleData  // Отправляем schedule data как тело запроса, а не как часть URL
    });

    return response.data;
  } catch (error) {
    console.error(`Error updating schedule for agent ID ${agentId}:`, error);
    throw error;
  }
};

/**
 * Add schedule entry
 *
 * @param {Object} data Schedule entry data
 * @returns {Promise<Object>} Result with new entry ID
 */
export const addScheduleEntry = async (data) => {
  try {
    const response = await apiRequest({
      url: '/api/schedule.php?method=add_entry',
      method: 'POST',
      data
    });

    return response.data;
  } catch (error) {
    console.error('Error adding schedule entry:', error);
    throw error;
  }
};

/**
 * Delete schedule entry
 *
 * @param {number} id Schedule entry ID
 * @returns {Promise<Object>} Result
 */
export const deleteScheduleEntry = async (id) => {
  try {
    const response = await apiRequest({
      url: `/api/schedule.php?method=delete_schedule&id=${id}`,
      method: 'POST'
    });

    return response.data;
  } catch (error) {
    console.error(`Error deleting schedule entry ID ${id}:`, error);
    throw error;
  }
};

/**
 * Check if agent is working at a specific time
 *
 * @param {number} agentId Agent ID
 * @param {string} dateTime ISO date/time string
 * @returns {Promise<Object>} Result with working status
 */
export const checkAgentWorkingStatus = async (agentId, dateTime) => {
  try {
    const encodedDateTime = encodeURIComponent(dateTime);
    const response = await apiRequest({
      url: `/api/schedule.php?method=check_working_status&agent_id=${agentId}&datetime=${encodedDateTime}`,
      method: 'GET'
    });

    return response.data;
  } catch (error) {
    console.error(`Error checking working status for agent ID ${agentId}:`, error);
    throw error;
  }
};
